import { createApi } from "@reduxjs/toolkit/query/react";
import CustomFetchBase from "../CustomFetchBase";

export const FaqApi = createApi({
  reducerPath: "FaqApi",
  baseQuery: CustomFetchBase,
  tagTypes: ["FAQAPI"],
  endpoints: (build) => ({
    getFaq: build.query({
      query: ({ page, searchTerm }) => ({
        url: `/faqs?page=${page}&search=${searchTerm}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["FAQAPI"],
    }),

    getFaqById: build.query({
      query: ({ id }) => ({
        url: `/faqs/${id}`,
        method: "GET",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      providesTags: ["FAQAPI"],
    }),

    editFaq: build.mutation({
      query: ({ id, data }) => ({
        url: `/faqs/${id}`,
        method: "PUT",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["FAQAPI"],
    }),

    addFaq: build.mutation({
      query: ({ data }) => ({
        url: `/faqs`,
        method: "POST",
        body: data,
        headers: {},
      }),
      invalidatesTags: ["FAQAPI"],
    }),

    deleteFaq: build.mutation({
      query: ({ id }) => ({
        url: `/faqs/${id}`,
        method: "DELETE",
        headers: {
          "Content-Type": "application/json; charset=UTF-8",
        },
      }),
      invalidatesTags: ["FAQAPI"],
    }),
  }),
});

export const {
  useGetFaqQuery,
  useGetFaqByIdQuery,
  useEditFaqMutation,
  useAddFaqMutation,
  useDeleteFaqMutation,
} = FaqApi;
